import React from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import language from "../../../language";
import { Tabs } from "../../../components/Tabs";
import { getStorage } from "../../../utils/storage";
import accessMenu from "../../../utils/accessMenu";
import ComponentLabeling from "../../../components/Production/ComponentLabeling/Labeling";
import NewReception from "../../../components/Production/reception/NewReception";
import { Inventories } from "../../../components/inventory";
import NewSeparation from "../../../components/Production/ComponentSeparation/NewSeparation";
import NewComponentTransformation from "../../../components/Production/ComponentTransformation/NewComponentTransformation";
import Separations from "../../../components/Production/ComponentSeparation/Separations";
import Rejected from "../../../components/inventory/rejected/historicalData";
import NewReject from "../../../components/inventory/rejected/NewReject";
import NewReverse from "../../../components/inventory/reverse/NewReverse";

class ProductionScreen extends React.Component {
  state = {
    user: {},
    showGuide: false,
    activeTab: null,
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });
  };
  render() {
    let {
      canReadProductionInventory,
      canReadProductionSection,
      canReadComponentSeparation,
      canReadComponentTransformation,
      canReadLabeling,
      canReadProductionRejectedProduct,
      canReadProductionReception,
      isLaboratoryStaff,
    } = accessMenu();
    let tabOptions = [];

    if (canReadProductionReception) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].reception,
        data: (
          <>
            <NewReception {...this.props.routeParams} />
          </>
        ),
      });
    }

    if (canReadProductionInventory && canReadProductionSection) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].inventory,
        data: (
          <>
            <Inventories {...this.props.routeParams} status="labelled" />
          </>
        ),
      });
    }

    if (canReadComponentSeparation) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].component_separation,
        data: (
          <Tabs
            options={[
              {
                title: language[this.props.defaultLanguage].new_record,
                data: <NewSeparation {...this.props.routeParams} />,
              },
              {
                title: language[this.props.defaultLanguage].historical_data,
                data: <Separations type="separation" />,
              },
            ]}
          />
        ),
      });
    }

    if (canReadLabeling && !isLaboratoryStaff) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].component_to_label,
        data: <ComponentLabeling {...this.props.routeParams} />,
      });
    }

    if (canReadComponentTransformation) {
      const transformationSubTabs = [
        {
          title: language[this.props.defaultLanguage].new_record,
          data: <NewComponentTransformation {...this.props.routeParams} />,
        },
        {
          title: language[this.props.defaultLanguage].historical_data,
          data: <Separations type="transformation" />,
        },
      ];

      tabOptions.push({
        title: language[this.props.defaultLanguage].component_transformation,
        data: <Tabs options={transformationSubTabs} />,
      });
    }

    if (canReadProductionRejectedProduct) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].rejection,
        data: (
          <Tabs
            options={[
              {
                title:
                  language[this.props.defaultLanguage].new_product_rejection,
                data: <NewReject {...this.props.routeParams} />,
              },
              {
                title: language[this.props.defaultLanguage].reverse,
                data: <NewReverse {...this.props.routeParams} />,
              },
              {
                title: language[this.props.defaultLanguage].historical_data,
                data: <Rejected {...this.props.routeParams} />,
              },
            ]}
          />
        ),
      });
    }

    const { showGuide, activeTab } = this.state;
    const rejectionTitle = language[this.props.defaultLanguage].rejection?.toLowerCase();
    const hideGuide = activeTab === rejectionTitle;

    return (
      <div>
        <div className="card-dashboard-content">
          <div className="card-body">
            <Tabs
              options={tabOptions}
              onSelect={(k) => this.setState({ activeTab: k, showGuide: false })}
            />
          </div>
        </div>

        {!hideGuide && (
          <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 1050 }}>
            {showGuide && (
              <div style={{
                position: "absolute",
                bottom: 54,
                right: 0,
                width: "min(400px, calc(100vw - 32px))",
                maxHeight: "75vh",
                background: "#fff",
                borderRadius: 10,
                boxShadow: "0 8px 32px rgba(0,0,0,0.22)",
                border: "1px solid #dee2e6",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}>
                <div style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  padding: "12px 16px", borderBottom: "1px solid #dee2e6",
                  background: "#f8f9fa", borderRadius: "10px 10px 0 0", flexShrink: 0,
                }}>
                  <span style={{ fontWeight: 700, fontSize: 14 }}>How to Use Component Production</span>
                  <button
                    onClick={() => this.setState({ showGuide: false })}
                    style={{ border: "none", background: "none", fontSize: 20, cursor: "pointer", color: "#888", lineHeight: 1, padding: 0 }}
                  >×</button>
                </div>

                <div style={{ overflowY: "auto", padding: "16px", fontSize: 13, lineHeight: 1.65 }}>
                  <p style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--primary-color)", fontWeight: 700, marginBottom: 6 }}>Overview</p>
                  <p style={{ marginBottom: 16 }}>
                    Component Production covers <strong>Reception</strong>, <strong>Component Separation</strong>, <strong>Labeling</strong>, and <strong>Transformation</strong>. Use the tabs at the top to navigate between these steps.
                  </p>

                  <p style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--primary-color)", fontWeight: 700, marginBottom: 6 }}>Selecting a Separation Profile</p>
                  <p style={{ marginBottom: 8 }}>Profiles must match the donation bag weight. Choosing the wrong profile will be blocked by the system.</p>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 16 }}>
                    {[
                      { label: "Normal Weight (525–621 g)", desc: "Profiles 1, 2, 3, 5, or 7 are allowed." },
                      { label: "Low Weight (414–524 g)", desc: "Profiles 4, 6, or 7 are allowed." },
                      { label: "Profile 7", desc: "Universal — allowed for both Normal and Low weight." },
                      { label: "Over / Under weight", desc: "≤ 413 g or ≥ 622 g donations are automatically rejected and cannot be separated." },
                    ].map(({ label, desc }) => (
                      <div key={label} style={{ border: "1px solid #e0e0e0", borderRadius: 6, padding: "8px 10px" }}>
                        <strong style={{ display: "block", marginBottom: 3, fontSize: 12 }}>{label}</strong>
                        <span style={{ fontSize: 11, color: "#555" }}>{desc}</span>
                      </div>
                    ))}
                  </div>

                  <p style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--primary-color)", fontWeight: 700, marginBottom: 6 }}>How to Separate a Donation</p>
                  <ol style={{ paddingLeft: 18, marginBottom: 16 }}>
                    <li>Select a <strong>Separation Profile</strong> from the dropdown.</li>
                    <li>Choose the <strong>Centrifuge</strong> and <strong>Separator</strong> used.</li>
                    <li>Enter the 7-digit <strong>Donation Number</strong> and click <strong>Search</strong>.</li>
                    <li>Component names and volumes are filled automatically from the profile.</li>
                    <li>Click <strong>Submit</strong> to record the separation.</li>
                  </ol>

                  <p style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--primary-color)", fontWeight: 700, marginBottom: 6 }}>Donation By Donation vs Bulk</p>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 16 }}>
                    {[
                      { label: "Donation By Donation", desc: "Process one donation at a time. Ideal for individual verification." },
                      { label: "Bulk Donation", desc: "Separate multiple donations at once using the same profile and equipment." },
                    ].map(({ label, desc }) => (
                      <div key={label} style={{ border: "1px solid #e0e0e0", borderRadius: 6, padding: "8px 10px" }}>
                        <strong style={{ display: "block", marginBottom: 3, fontSize: 12 }}>{label}</strong>
                        <span style={{ fontSize: 11, color: "#555" }}>{desc}</span>
                      </div>
                    ))}
                  </div>

                  <div style={{ background: "#fff8e1", border: "1px solid #f59e0b", borderRadius: 6, padding: "8px 12px", display: "flex", gap: 8, alignItems: "flex-start" }}>
                    <span style={{ fontSize: 15, lineHeight: 1.4 }}>⚠</span>
                    <span style={{ fontSize: 11, color: "#92400e", lineHeight: 1.5 }}>
                      <strong>Note:</strong> Apheresis products (codes 13000, 13100, etc.) are already separated by the collection machine — do <em>not</em> separate them here. Proceed directly to <em>Labeling</em>. Each component can only be separated once per donation.
                    </span>
                  </div>
                </div>
              </div>
            )}

            <button
              title="How to use Component Production"
              onClick={() => this.setState(prev => ({ showGuide: !prev.showGuide }))}
              style={{
                width: 44, height: 44, borderRadius: "50%",
                backgroundColor: showGuide ? "#fff" : "var(--primary-color)",
                color: showGuide ? "var(--primary-color)" : "#fff",
                border: "2px solid var(--primary-color)",
                boxShadow: "0 3px 10px rgba(0,0,0,0.28)",
                cursor: "pointer", fontSize: 22, fontWeight: 700,
                display: "flex", alignItems: "center", justifyContent: "center",
                lineHeight: 1,
              }}
            >?</button>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(withRouter(ProductionScreen));
